import { apiService } from './api'
import { z } from 'zod'
import { CONTACTS_ENDPOINTS } from '../../api/endpoints'

// Schema for contactgegevens item
const ContactgegevenSchema = z.object({
  id: z.string(),
  bestand: z.string().nullable(),
  categorie: z.string().nullable(),
  subcategorie: z.string().nullable(),
  organisatie: z.string().nullable(),
  naamFunctie: z.string().nullable(),
  mail: z.string().nullable(),
  telefoonVast: z.string().nullable(),
  mobiel: z.string().nullable(),
  calamiteitennr: z.string().nullable(),
  opmerkingen: z.string().nullable(),
  createdAt: z.string().nullable(),
})

const ContactgegevensListResponseSchema = z.object({
  data: z.array(ContactgegevenSchema),
})

// Schema for cleanup response
const CleanupResponseSchema = z.object({
  data: z.object({
    contactgegevens_deleted: z.number(),
    piketnummers_deleted: z.number(),
    total_deleted: z.number(),
  }),
})

// Schema for refresh response
const RefreshResponseSchema = z.object({
  data: z.object({
    status: z.string(),
    crisis_id: z.string(),
    job_id: z.string(),
    contactgegevens_deleted: z.number(),
    piketnummers_deleted: z.number(),
    message: z.string(),
  }),
})

export type Contactgegeven = z.infer<typeof ContactgegevenSchema>
export type CleanupResult = z.infer<typeof CleanupResponseSchema>['data']
export type ContactgegevensListResponse = z.infer<typeof ContactgegevensListResponseSchema>
export type CleanupResponse = z.infer<typeof CleanupResponseSchema>
export type RefreshResult = z.infer<typeof RefreshResponseSchema>['data']
export type RefreshResponse = z.infer<typeof RefreshResponseSchema>

class ContactsService {
  /**
   * Get all contactgegevens for the active crisis
   */
  async getContactgegevens(): Promise<Contactgegeven[]> {
    const response = (await apiService.get(
      CONTACTS_ENDPOINTS.CONTACTGEGEVENS,
      ContactgegevensListResponseSchema
    )) as ContactgegevensListResponse
    return response.data
  }

  /**
   * Clean up orphaned contacts (not associated with active crises)
   */
  async cleanupOrphanedContacts(): Promise<CleanupResult> {
    const response = (await apiService.post(
      CONTACTS_ENDPOINTS.CLEANUP,
      CleanupResponseSchema
    )) as CleanupResponse
    return response.data
  }

  /**
   * Refresh contacts by deleting existing data and re-importing from SharePoint
   */
  async refreshContacts(): Promise<RefreshResult> {
    const response = (await apiService.post(
      CONTACTS_ENDPOINTS.REFRESH,
      RefreshResponseSchema
    )) as RefreshResponse
    return response.data
  }
}

export const contactsService = new ContactsService()
